import { connectInput } from 'lib/form';
import { TextInput } from '../common';

const TextField = connectInput(TextInput);

export default TextField;
